/**
 * Soft paywall wrapper for every /admin/* page.
 *
 * Behavior:
 *   - Active subscription, grandfathered, or still on the free listing
 *     -> render the page, with nothing in the way.
 *   - Lapsed agents see a hard paywall instead of the page.
 *
 * There is no trial nudge any more. While an agent is on their free listing
 * there is nothing to count down to, and a banner tracking their progress
 * toward a paywall would undercut the one thing the pricing promises. The
 * only place an agent meets the subscription is the moment they add a
 * SECOND client, and that prompt lives on the client list, not up here.
 */
import React from "react";
import { useAuth } from "../lib/auth";
import BillingPaywall, { useBilling } from "./BillingPaywall";

export default function AdminBillingGate({ children }) {
  const { user } = useAuth();
  const { status, loading, isAgent } = useBilling(user);

  // Sellers (or admins inside the impersonate flow) bypass billing entirely.
  if (!isAgent) return children;
  // While the first request is in flight, render children to avoid a flash -
  // the gate only gets in the way once we have confirmed the lapse.
  if (loading || !status) return children;

  if (status.active) return children;

  // Lapsed -> hard paywall instead of the page.
  return (
    <div data-testid="admin-billing-locked" style={{ padding: "12px 0" }}>
      <BillingPaywall status={status} />
    </div>
  );
}
